import { render } from "./BattleProfitChart.vue?vue&type=template&id=6d5d6f22"
import script from "./BattleProfitChart.vue?vue&type=script&lang=js"
export * from "./BattleProfitChart.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__